import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { CaretDown } from "components/icons/CaretDown";
import { RegistrationIntent } from "./constants";

type AddStateDropdownProps = {
  onSelectIntent: (intent: RegistrationIntent) => void;
};

export const AddStateDropdown = ({ onSelectIntent }: AddStateDropdownProps) => {
  return (
    <Dropdown.Root>
      <Dropdown.Trigger asChild>
        <Button
          customType="primary"
          size="small"
          className="t-group"
          rightIcon={
            <span className="t-flex t-transform t-transition t-duration-300 t-ease-in-out group-data-state-open:-t-rotate-180">
              <CaretDown />
            </span>
          }
        >
          Add state
        </Button>
      </Dropdown.Trigger>
      <Dropdown.Portal>
        <Dropdown.Content align="end" sideOffset={4}>
          <Dropdown.Item onSelect={() => onSelectIntent("new")}>
            <div className="t-flex t-flex-col t-py-0.5 t-text-body t-text-text-100">
              Register in a new state
              <span className="t-text-body-sm-lite t-text-text-30">
                Inkle handles the registration for you
              </span>
            </div>
          </Dropdown.Item>
          <Dropdown.Item onSelect={() => onSelectIntent("existing")}>
            <div className="t-flex t-flex-col t-py-0.5 t-text-body t-text-text-100">
              Already registered in this state
              <span className="t-text-body-sm-lite t-text-text-30">
                Add details of an existing registration
              </span>
            </div>
          </Dropdown.Item>
        </Dropdown.Content>
      </Dropdown.Portal>
    </Dropdown.Root>
  );
};
